// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__3fUGw","Loading":"Gallery_Loading__1FO2u"};